import { useContext, useState } from "react"
import { Link } from "react-router-dom"
import { AuthLayout, BrandLogo, ForgotPasswordForm } from "@/components"
import { requestPasswordReset } from "../system/api.js"
import { ThemeContext } from "../providers/ThemeProvider.jsx"

export default function ForgotPassword() {
  const { theme } = useContext(ThemeContext)
  const isDark = theme === "dark"

  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)
  const [error, setError] = useState(undefined)
  const [submittedEmail, setSubmittedEmail] = useState("")

  const handleSubmit = async (email) => {
    if (loading) return

    if (!email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError("Enter a valid email address")
      return
    }

    setError(undefined)
    setLoading(true)
    setSubmittedEmail(email)

    try {
      await requestPasswordReset(email)
      setSent(true)
    } catch {
      setError("An error occurred. Please try again later.")
    } finally {
      setLoading(false)
    }
  }

  return (
    <AuthLayout
      brandSlot={
        <a href="https://algobuilder.com">
          <BrandLogo height={22} theme={isDark ? "dark" : "light"} />
        </a>
      }
      footerSlot={
        <>&copy; {new Date().getFullYear()} AlgoBuilder. All rights reserved.</>
      }
    >
      <ForgotPasswordForm
        sent={sent}
        sentEmail={submittedEmail}
        loading={loading}
        error={error}
        sentMessage={
          <>
            We&apos;ve sent password reset instructions to{" "}
            <strong className="text-foreground">{submittedEmail}</strong> if an
            account exists. Check your inbox.
          </>
        }
        backLinkSlot={
          <Link
            to="/sign/in"
            className="text-primary hover:text-primary/80 no-underline font-semibold transition-colors"
          >
            Back to Login
          </Link>
        }
        sentBackLinkSlot={
          <Link
            to="/sign/in"
            className="text-body text-primary hover:text-primary/80 no-underline font-semibold transition-colors"
          >
            Back to Login
          </Link>
        }
        onSubmit={handleSubmit}
      />
    </AuthLayout>
  )
}
